import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-transformers',
  templateUrl: './transformers.component.html',
  styleUrls: ['./transformers.component.scss'],
  standalone:true,
  imports:[CommonModule]
})
export class TransformersComponent implements OnInit {
  @Input() tabName:any="";
  @Input() tab1:any="";
  @Input() tab2:any="";
  @Input() tab3:any="";
  @Input() tab4:any=""; 
  

  constructor(public router: Router,) { }

  ngOnInit(): void {
  }
  transformerDetailScreen(){
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        trasnformerId:'EM1234590',
        tabName:"tab-2",
        tab1:this.tab1,
        tab2:true,
        tab3:this.tab3,
        tab4:this.tab4
      }
    }
    this.router.navigate(['transformer-analysis'], navigationExtras);
  }
}
